import Backbone from 'backbone';
import BackboneValidation from 'backbone-validation';
import BackboneDeepModel from '@kahwee/backbone-deep-model';
import Handlebars from 'handlebars';
import UsersCollection from './collections/collection.users';
import UserModel from './models/model.user';
import FTSIrouter from './routes/router.firstTimeSignin';
import Utils from './utils';
import {
  isPublish
} from '../../base/vars';

window.App = {};
window.Backbone = Backbone;
window.Backbone.Validation = BackboneValidation;
window.Backbone.DeepModel = BackboneDeepModel;
window.Handlebars = Handlebars;

$(() => {
  if (isPublish) {
    Utils.applicationFlow = 'ftsi';
    window.App.Collections = window.App.Collections || {};
    window.App.Collections.Users = new UsersCollection([new UserModel()]);
    window.App.Events = _.extend({}, Backbone.Events);
    window.App.Router = new FTSIrouter();
    Backbone.history.start();
  }
});
